import { Group, Radio } from '@mantine/core';
import { useVisibilityLevelContext } from '../contexts/VisibilityLevelContext';
import { VISIBILITY_LEVEL } from '../types/level';

export const FormOptions = () => {
  const { updateVisibilityLevel, visibilityLevel } = useVisibilityLevelContext();

  return (
    <Group justify='end'>
      <Radio
        checked={visibilityLevel === VISIBILITY_LEVEL.BASIC}
        onChange={() => updateVisibilityLevel(VISIBILITY_LEVEL.BASIC)}
        label='Basic'
      />
      <Radio
        checked={visibilityLevel === VISIBILITY_LEVEL.ADVANCED}
        onChange={() => updateVisibilityLevel(VISIBILITY_LEVEL.ADVANCED)}
        label='Advanced'
      />
      <Radio
        checked={visibilityLevel === VISIBILITY_LEVEL.EXPERT}
        onChange={() => updateVisibilityLevel(VISIBILITY_LEVEL.EXPERT)}
        label='Expert'
      />
    </Group>
  );
};
